import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Submits functional usage alongside the record edits it was captured with.
 */
export const submitOnEditingSubmit = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.editingPlugin.feature.actions.submit.request
      .observe()
      .pipe(
        rxjs.map(action =>
          feature.actions.submit.request.from(action).create(),
        ),
      ),
)
